import {takeFirstDefinedForKeys} from 'powtoon-commons/utils'
import {getInitialWebVars} from 'powtoon-commons/utils/webvars'

const webvars = getInitialWebVars(({is_prod_env}) => is_prod_env)

const getDefaultAppcuesTourId = () => webvars.is_enterprise
  ? '29f3b17d-d4d7-4747-bd82-cc0e41f9a68b'
  : '459171cf-d632-4389-81a3-7ec681975ef8'

export const assignedWebVars = takeFirstDefinedForKeys({
  logzioId:                   [webvars.logzio_id, null],
  logzioMetricsId:            [webvars.logzio_metrics_id, 'LOGZIO_METRICS_ID_IS_MISSED'],
  logzioUrl:                  [ webvars.logzio_url, 'https://listener.logz.io:8091' ],
  apiHost:                    [process.env.API_HOST, webvars.api_host, ''],
  cdnApiHost:                 [webvars.cdn_api_host, ''],
  isProdEnv:                  [webvars.is_prod_env, false],
  userId:                     [webvars.user_id, null],
  pusherKey:                  [process.env.PUSHER_KEY, webvars.pusher_key, 'PUSH_KEY_IS_MISSING'],
  allowOptOut:                [webvars.allow_opt_out, false],
  spaContentMode:             [webvars.spa_content_mode, 'original'],
  trialTimerMode:             [webvars.trial_timer_mode, 'default'],
  gdprRequired:               [webvars.gdpr_required, true],
  skipUserOnboarding:         [webvars.skip_user_onboarding],
  enableClassroom:            [webvars.enable_edu_classroom_capabilities, 'enabled'],
  showCaptureElements:        [webvars.show_capture_elements, false],
  showCaptureElementsDuplicate:  [webvars.show_capture_elements_duplicate, false],
  limitationsPhase2:          [webvars.limitations_phase_2, true],
  recaptchaId:                [webvars.recaptcha_id, '6LcgzGAUAAAAAOyZuVKEfviWCc4fpDkPZFWqCdsx'],
  recaptchaEnabled:           [webvars.recaptcha_enabled, true],
  shareUrlFormat:             [webvars.share_url_format, 'SHARE_URL_FORMAT_IS_MISSING'],
  showAppsIntegrationsWidget: [webvars.show_apps_integrations_widget, true],
  embeddedSessionId:          [webvars.embedded_session_id, null],
  sessionId:                  [webvars.session_id, webvars.embedded_session_id, null],
  showTourButton:             [webvars.show_tour_button, false],
  adminHost:                  [webvars.admin_host, '/admin'],
  loginSessionId:             [webvars.login_session_id, null],
  clientIP:                   [webvars.client_ip, null],
  appLevel:                   [webvars.APP_LEVEL, null],
  lti:                        [webvars.lti, null],
  enableUpgrades:             [webvars.enable_upgrades, true],
  hideUserName:               [webvars.app_settings?.hide_user_name, false],
  hideAccountInfo:            [webvars.app_settings?.hide_account_info, false],
  hideMoreMenu:               [webvars.app_settings?.hide_more_menu, false],
  isEnterprise:               [webvars.is_enterprise, false],
  enableOrgFeatures:          [ webvars.enable_org_features, webvars.is_enterprise, false ],
  enableTranslations:         [webvars.enable_translations, false],
  enableIndividualSharing:    [webvars.enable_individual_sharing, false],
  pusherRegion:               [webvars.pusher_region],
  appcuesTourId:              [webvars.appcues_tour_id, getDefaultAppcuesTourId()],
  powtoonContextMenuMode:     [webvars.app_settings?.powtoon_context_menu_mode, ''],
  enablePowtoonMultiselect:   [webvars.app_settings?.powtoon_multiselect_enabled, true],
  showUserBar:                [webvars.app_settings?.show_user_bar, false],
  externalStudioLink:         [webvars.app_settings?.external_studio_link, ''],
  externalShareLink:          [webvars.app_settings?.external_share_link, ''],
  showSearchPowtoonInput:     [webvars.app_settings?.show_search_powtoon_input, true],
  showCreatePowtoonFolderButton: [webvars.app_settings?.show_create_powtoon_folder_button, true],
  enableShareLink:            [webvars.app_settings?.enable_share_link, true],
  enableContextMenu:          [webvars.app_settings?.enable_context_menu, true],
  editPowtoonFlow:            [webvars.app_settings?.edit_powtoon_flow, 'default'],
  predefinedUrls:             [webvars.app_settings?.predefined_urls, {}],
  captureExtensionStoreLink:  [webvars.capture_extension_store_link,
                               webvars.chrome_extension_store_link,
                               'https://chrome.google.com/webstore/detail/powtoon-capture-screen-an/hgphbmgpkindhnldhjafhfflhjodpfmn?hl=en'],
  captureExtensionId:         [webvars.capture_extension_id,
                               webvars.extension_id,
                               'hgphbmgpkindhnldhjafhfflhjodpfmn'],
  userOnboardingMode:         [webvars.user_onboarding_mode, 'default'],
  showAccountBtn:             [webvars.app_settings?.show_account_btn, false],
  showCreateBtn:              [webvars.show_create_btn, false],
  orgTemplatesEnabled:        [webvars.org_templates_enabled, false],
  useCustomShareWithTeamTaskModal:      [webvars.app_settings?.use_custom_share_with_team_task_modal, false],
  enableInviteTrialMember:    [webvars.enableInviteTrialMember, false],
  showHelp:                   [webvars.app_settings?.show_help, true],
  showToolsPanel:             [webvars.app_settings?.show_tools_panel, true],
  showTeamsTab:               [webvars.app_settings?.show_teams_tab, true],
  customPublishUrlFormat:     [webvars.app_settings?.custom_publish_url_format, null],
  viewOnlyModeEnabled:        [webvars.view_only_mode_enabled, false],
  apiApplicationId:           [webvars.api_application_id, null],
  powtoonUpsellMode:          [webvars.powtoon_upsell_mode, true],
  arenaUrl:                   [webvars.arena_url, '/arena?action=auth'],
  enableArena:                [webvars.enable_arena, false],
  licenseGeneration:          [webvars.license_generation, null],
  enableFilterByFormat:       [webvars.enable_filter_by_format, false],
  workspaceHomeWidgetsMode:   [webvars.workspace_home_widgets_mode, 'default'],
  vtCollectionId:             [webvars.vt_collection_id, null],
  enableNewTemplatePreviewModal:  [webvars.enable_new_template_preview_modal, false],
  enableAnonymousTemplatePreviewLink:  [webvars.enable_anonymous_template_preview_link, false],
  enableLicensedGroupInvitations:  [webvars.enable_licensed_group_invitations, false],
  enableVideoTrimming:        [webvars.enable_video_trimming, false],
  enableInvitingGuests:       [webvars.enable_inviting_guests, false],
  enableAiTools:              [webvars.enable_ai_tools, false],
  enableAiScriptingTool:      [webvars.enable_ai_scripting_tool, false],
  enableAiScriptingToolWithDocsImport: [webvars.enable_ai_scripting_tool_with_docs_import, false],
  enableScriptToVideoGeneration: [webvars.enable_script_to_video_generation, false],
  enablePresentationsAndTtsCard:    [webvars.enable_presentations_and_tts_card, false],
  mostPopularBySegment:       [webvars.most_popular_by_segment, false],
  enableArenaTheme:           [webvars.enable_arena_theme, false],
  enableTextToSpeechNewService:     [webvars.enable_text_to_speech_new_service, false],
  enableTextToSpeech:         [webvars.enable_text_to_speech, false],
  aiProducerToolUrl:          [webvars.ai_producer_tool_url, null],
  enableAiProducerTool:       [webvars.enable_ai_producer_tool, false],
  unauthMaxDailyProducerGenerations:    [webvars.unauth_max_daily_producer_generations, false],
  canUseTtsPermissionDebug:   [webvars.can_use_tts_permission_debug, webvars.is_enterprise, false],
  enableFeatureTryouts:       [webvars.enable_feature_tryouts, false],
  enableRealisticAvatars:     [webvars.enable_realistic_avatars, false],
  enableWorkspaceWithLobbies: [webvars.enable_workspace_with_lobbies, false],
  isLocalhost:                [webvars.is_localhost, false],
  enableCreditSystem:         [webvars.enable_credit_system, false],
  creditSystemMode:           [webvars.credit_system_mode, 'visible'],
  paypalDeactivated:          [webvars.paypal_deactivated, true],
  enablePurchasePageRedesign: [webvars.enable_purchase_page_redesign, false],
  startSaleCampaign:          [webvars.start_sale_campaign, '2025-03-17T22:00:00Z'],
  endSaleCampaign:            [webvars.end_sale_campaign, '2025-04-03T08:00:00Z'],
  powtoonsCreatedAmount:      [webvars.powtoons_created_amount, 0],
  enableOnboardingReferralQuestion: [webvars.enable_onboarding_referral_question, false],
  enableCaptionsTool:         [webvars.enable_captions_tool, false],
  enableOnboardingWithTemplateChooser: [webvars.enable_onboarding_with_template_chooser, false],
  enableTextToVideo:          [webvars.enable_text_to_video, false],
  enableAiPowtoonTranslation: [webvars.enable_ai_powtoon_translation, false],
  enableTextToImage:          [webvars.enable_text_to_image, false],
  enableApiApplicationAdminPanel: [webvars.enable_api_application_admin_panel, false],
  enableDoc2VidMicroservice:  [webvars.enable_doc2vid_microservice, false]
})

export default {
  getWebVars: () => assignedWebVars,
  getWebVar: (propName: string) => assignedWebVars[propName]
}
